import { render, staticRenderFns } from "./Invitation.vue?vue&type=template&id=a8283cbc&lang=html"
import script from "./Invitation.vue?vue&type=script&lang=js"
export * from "./Invitation.vue?vue&type=script&lang=js"
import style0 from "./Invitation.vue?vue&type=style&index=0&id=a8283cbc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports